// extracted by mini-css-extract-plugin
export var dropdownContainer = "_rg-0";
export var leftAlign = "_rg-4";
export var listItem = "_rg-2";
export var listItemWrapper = "_rg-1";
export var operationText = "_rg-3";